<template>
	<div>
		<div v-if="form.type==1" style="width: 800px; margin: 30px auto">
			<h1 style="text-align: center">青岛辖区证券从业人员基本信息公示</h1>
			<div style="margin-right: 50px;margin-left: 50px">
				<div>
					<el-form ref="form" :rules="rules" :model="form" label-width="80px" label-position="top">
						<el-row :gutter="20">
							<el-col :span="10" :offset="1">
								<el-form-item label="从业人员姓名">
									<el-input v-model="form.practitionerName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10" :offset="2">
								<el-form-item label="从业人员登记编号" style="margin-bottom: 0">
									<el-input v-model="form.serPraNumber"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20" style="position: relative;bottom: 10px">
							<el-col :span="10" :offset="1">
								<el-form-item label="证券机构名称">
									<el-input v-model="form.serNumber"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
				<div class="btw">
					<el-button class="buttonT" type="primary" @click="searchP">开 始 查 询</el-button>
				</div>
				<div class="line">
					<el-divider content-position="center">查询结果</el-divider>
				</div>
				<div v-if="showCom===3" style="text-align: center">
					<p>{{ msg }}</p>
				</div>
				<div v-if="showCom===1" style="width: 902px;position: relative;right: 92px">
					<el-table class="tableBox" border :data="table" :row-style="rowstyles" :header-cell-style="{backgroundColor:'#81adda',color:'white',height: '40px',fontsize:'16px'}">
						<el-table-column label="姓 名" align="center" width="108">
							<template slot-scope="scope">
								<div style="cursor:pointer; color: #0844f2" @click="check(scope.row.id)">
									{{ scope.row.practitionerName }}
								</div>
								<!--                <el-button style="height: 20px;margin: 0;padding: 0;font-size: 16px;color:#0844f2" type="text"-->
								<!--                           @click="check(scope.row.id)">{{ scope.row.practitionerName }}-->
								<!--                </el-button>-->
							</template>
						</el-table-column>
						<el-table-column label="性 别" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.practitionerSex }}
							</template>
						</el-table-column>
						<el-table-column width="145" prop="registrationNumber" label="登记编号" align="center" />
						<el-table-column width="108" prop="personnelCategory" label="人员类别" align="center" />
						<el-table-column width="459" prop="organizationName" label="证券机构名称" align="center" />
					</el-table>


				</div>
				<div v-if="showCom===2" style="height:400px;border-top-color: #164480;position: relative;right:0px">
					<div style="margin: 0 auto;height: 300px;width:687px;border:1px solid #d7e7f2;font-size: 16px ;color:black">
						<div style="display: flex;">
							<div class="three_rows">
								<div class="small_row">
									<div class="labell">姓 名</div>
									<div class="valuee"><span class="content">{{ info.practitionerName }}</span></div>
									<div class="labell">性 别</div>
									<div class="valuee"><span class="content">{{ info.practitionerSex }}</span></div>
								</div>
								<div class="small_row">
									<div class="labell">学 历</div>
									<div class="valuee"><span class="content">{{ info.education }}</span></div>
									<div class="labell">备案状态</div>
									<div class="valuee"><span class="content">{{ info.enrollmentStatus }}</span></div>
								</div>
								<div class="small_row">
									<div class="labell">岗 位</div>
									<div class="valuee"><span class="content">{{ info.postName }}</span></div>
									<div class="labell">备案时间</div>
									<div class="valuee"><span class="content">{{ info.registrationTime }}</span></div>
								</div>
							</div>
							<div class="profile">
								<img :src="info.avatar" alt="暂无照片" style="height: 100%; width: 100%" />
							</div>
						</div>

						<div class="big_row">
							<div class="labell">人员类别</div>
							<div class="valuee" style="border-bottom:1px solid #d7e7f2;"><span
									class="content">{{ info.personnelCategory }}</span></div>
							<div class="labell">登记编号</div>
							<div class="valueBig" style="border-bottom:1px solid #d7e7f2"><span
									class="content">{{ info.registrationNumber }}</span></div>
						</div>
						<div class="big_row last_line">
							<div class="labell" style="height: 59px">合同状态</div>
							<div class="valuee" style="height: 59px;">
								<span class="content">{{ info.contractStatus }}</span>
							</div>
							<div class="labell" style="height: 59px;">所在机构</div>
							<div class="valueBig"><span class="content">{{ info.organizationName }}</span></div>
						</div>
					</div>
				</div>
				<pagination style="text-align: center" v-show="total>0&&showCom===1" :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize" @pagination="searchP" />
			</div>
		</div>


		<div v-if="form.type==2" style="width: 800px; margin: 30px auto">
			<h1 style="text-align: center">青岛辖区期货从业人员及居间人基本信息公示</h1>
			<div style="margin-right: 50px;margin-left: 50px">
				<div>
					<el-form ref="form" :rules="rules" :model="form" label-width="80px" label-position="top">
						<el-row :gutter="20">
							<el-col :span="10" :offset="0">
								<el-form-item label="从业人员/居间人姓名">
									<el-input v-model="form.practitionerName"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="10" :offset="4">
								<el-form-item label="登记编号" style="margin-bottom: 0">
									<el-input v-model="form.serPraNumber"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row :gutter="20" style="position: relative;bottom: 10px">
							<el-col :span="10" :offset="0">
								<el-form-item label="期货机构名称">
									<el-input v-model="form.serNumber"></el-input>
								</el-form-item>
							</el-col>
              <el-col :span="10" :offset="4">
                <el-form-item label="从业资格号" style="margin-bottom: 0">
                  <el-input v-model="form.practitionerNumber"></el-input>
                </el-form-item>
              </el-col>
						</el-row>
					</el-form>
				</div>
				<div class="btw">
					<el-button class="buttonT" type="primary" @click="searchP">开 始 查 询</el-button>
				</div>
				<div class="line">
					<el-divider content-position="center">查询结果</el-divider>
				</div>
				<div v-if="showCom===3" style="text-align: center">
					<p>{{ msg }}</p>
				</div>
				<div v-if="showCom===1" style="width: 958px;position: relative;right: 126px">
					<el-table class="tableBox" border :data="table" :row-style="rowstyles"
						:header-cell-style="{backgroundColor:'#81adda',color:'white',height: '40px',fontsize:'16px'}">
						<el-table-column label="姓 名" align="center" width="145">
							<template slot-scope="scope">
								<div style="cursor:pointer; color: #0844f2" @click="check(scope.row.id)">
									{{ scope.row.practitionerName ||scope.row.agencyIntermediaryName}}
								</div>
							</template>
						</el-table-column>
						<el-table-column label="性 别" align="center" width="80">
							<template slot-scope="scope">
								{{ scope.row.practitionerSex }}
							</template>
						</el-table-column>
						<el-table-column width="175" prop="registrationNumber" :render-header="renderHeader" label="从业资格号/登记编号" align="center">
							<template slot-scope="scope">
								{{ scope.row.registrationNumber||scope.row.practitionerNumber }}
							</template>
						</el-table-column>
						<el-table-column width="108" prop="personnelCategory" label="人员类别" align="center" />
						<el-table-column width="448" prop="organizationName" label="期货机构名称" align="center" />
					</el-table>
				</div>
				<div v-if="showCom===2" style="height:400px;border-top-color: #164480;position: relative;right:0px">
					<div style="margin: 0 auto;height: 300px;width:687px;border:1px solid #d7e7f2;font-size: 16px ;color:black">
						<div style="display: flex;">
							<div class="three_rows">
								<div class="small_row">
									<div class="labell">姓 名</div>
									<div class="valuee ">
										<span class="content">{{ info.practitionerName||info.agencyIntermediaryName }}</span>
									</div>
									<div class="labell">性 别</div>
									<div class="valuee">
										<span class="content">{{ info.practitionerSex }}</span>
									</div>
								</div>
								<div class="small_row">
									<div class="labell">学 历</div>
									<div class="valuee"><span class="content">{{ info.education }}</span></div>
									<div class="labell">备案状态</div>
									<div class="valuee">
                    <span class="content">{{ info.enrollmentStatus }}</span>
                  </div>
								</div>
								<div class="small_row">
									<div class="labell">岗 位</div>
									<div class="valuee"><span class="content">{{ info.postName }}</span></div>
									<div class="labell">备案时间</div>
									<div class="valuee"><span class="content">{{ info.registrationTime }}</span></div>
								</div>
							</div>
							<div class="profile">
								<img class="imgNone" :src="info.avatar" style="height: 100%; width: 100%" />
							</div>
						</div>

						<div class="big_row">
							<div class="labell">人员类别</div>
							<div class="valuee" style="border-bottom:1px solid #d7e7f2;"><span
									class="content">{{ info.personnelCategory }}</span></div>
							<div class="labell" v-show="info.personnelCategory=='从业人员'">从业资格号</div>
							<div class="labell" v-show="info.personnelCategory=='居间人'">登记编号</div>
							<div class="valueBig" style="border-bottom:1px solid #d7e7f2"><span
									class="content">{{ info.registrationNumber||info.practitionerNumber }}</span></div>
						</div>
						<div class="big_row last_line">
							<div class="labell" style="height: 59px">合同状态</div>
							<div class="valuee" style="height: 59px;"><span
									class="content">{{ info.contractStatus }}</span></div>
							<div class="labell" style="height: 59px;">所在机构</div>
							<div class="valueBig"><span class="content">{{ info.organizationName }}</span></div>
						</div>
					</div>
				</div>
				<pagination style="text-align: center" v-show="total>0&&showCom===1" :total="total" :page.sync="form.pageNum" :limit.sync="form.pageSize" @pagination="searchP" />
			</div>

		</div>
	</div>
</template>

<script>
	import {
		getPractitioner,
		getInfoPractitioner
	} from '../api/index'

	export default {
		name: 'qdmap',

		data() {
			return {

				total: 0,
				msg: '',
				info: {},
				table: [],
				showCom: 0,
				form: {
					pageNum: 1,
					pageSize: 20,
					type: this.$route.params.type,
				},

				rules: {
					practitionerName: [{
						required: true,
						message: '请输入人员名称',
						trigger: 'blur'
					}, ]
				}
			}
		},
		mounted() {

		},
		created() {

		},
		methods: {
			renderHeader(h, {
				column
			}) {

				return h('span', {}, [
					h('span', {}, column.label.split(' ')[0]),
					h('br'),
					h('span', {}, column.label.split(' ')[1])
				])
			},
			rowstyles() {
				let styleJson = {
					"height": "20px",
					"font-size": "16px"
				}
				return styleJson
			},
			check(id) {
				this.showCom = 2;
				getInfoPractitioner(id).then(res => {
					this.info = res.data.data

				})
			},
			searchP() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						getPractitioner(this.form).then(res => {
							if (res.data.code === 200) {
								this.total = res.data.total
								this.table = res.data.rows
								this.showCom = 1;
							} else {
								this.msg = res.data.msg;
								this.showCom = 3;
							}
						})
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.three_rows {
		height: 180px;
		width: 550px;
		// float: left;

	}

	.profile {
		width: 135px;
		height: 180px;
		float: left;
		border-bottom: 1px solid #d7e7f2;

		padding: 10px 5px 10px 5px
	}

	.small_row {
		height: 60px;
		width: 550px;
		border-bottom: 1px solid #d7e7f2;
		border-right: 1px solid #d7e7f2;
	}

	.labell {
		width: 100px;
		height: 60px;
		float: left;
		text-align: center;
		line-height: 60px;
		background-color: #e8f4fb;
		border-right: 1px solid #d7e7f2;
		border-bottom: 1px solid #d7e7f2;

	}

	.valuee {
		width: 170px;
		height: 60px;
		float: left;
		text-align: center;
		text-align: center;
		display: table;
		vertical-align: middle;

	}

	.big_row {
		width: 690px;
		height: 60px;

	}

	.valueBig {
		width: 315px;
		height: 60px;
		float: left;

		text-align: center;
		display: table;
		vertical-align: middle;
	}

	.content {
		display: table-cell;
		vertical-align: middle;
	}

	.line {
		width: 100%;
		height: 60px;
		margin: 15px auto;
		position: relative;
		top: 10px;
	}

	.el-divider__text {
		color: #164480;
		font: 20px Arial bold;
	}

	.el-divider {
		background-color: #154480;
	}


	.el-table--border,
	.el-table--group {
		border: 1px solid #B9E3F3;
	}

	.btw {
		text-align: center;
		margin-top: 8px;
	}

	.el-table {
		font-size: 16px;
		color: black;
	}

	.el-button {
		width: 60%;
		height: 50px;
		margin-top: 25px;
		margin-bottom: 30px;
	}

	::v-deep.el-form-item>label {
		position: relative;
		bottom: -5px;
	}

	.el-button--primary {
		color: #FFF;
		background-color: #81adda;
		border-color: #81adda;
		font-size: 22px;

	}


	.l {
		background-color: #ecf2f9;
	}

	::v-deep.el-form-item>label {
		color: black !important;
		font-size: 16px;
	}

	::v-deep.el-button.el-button--text {
		margin: 0;
		padding: 0;
	}

	img[src=""],
	img:not([src]) {

		opacity: 0;

	}
</style>
